import { render, staticRenderFns } from "./ManagementNav.vue?vue&type=template&id=a8bcea0c&scoped=true&"
import script from "./ManagementNav.vue?vue&type=script&lang=js&"
export * from "./ManagementNav.vue?vue&type=script&lang=js&"
import style0 from "./ManagementNav.vue?vue&type=style&index=0&id=a8bcea0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bcea0c",
  null
  
)

export default component.exports